<div class="flex flex-col gap-4 w-full h-full" data-testid="cta-analytics-dialog-content">
  <app-cta-analytics-table
    class="h-full"
    [adminMode]="adminMode()"
    [analyticsNode]="analyticsNode()"
    [backToOverviewRequest]="backToOverviewRequest()"
    [briefingId]="briefingId()"
    [campaignExport]="campaignExport()"
    [campaignProcessStatus]="campaignProcessStatus()"
    [campaignStatus]="campaign()?.status"
    [creator]="creator()"
    [creatorBriefingMode]="creatorBriefingMode()"
    [ctaResult]="ctaResult()"
    [exportMode]="exportMode()"
    [selectedDeliverableExecutionAnalytics]="selectedDeliverableExecutionAnalytics()"
    [selectedDeliverableId]="selectedDeliverableId()"
    [selectedDeliverableType]="selectedDeliverableType()"
    (ctaExecutionChange)="ctaExecutionChange.emit($event)"
    (deliverableSelected)="deliverableSelected.emit($event)"
    (detailViewChange)="detailViewChange.emit($event)"
    (overviewRequested)="overviewRequested.emit()"
  />
</div>
